// @flow
import React from 'react';

type Props = {
  img: string;
  click: (e: SyntheticEvent<HTMLDivElement | HTMLImageElement>) => void;
  imgSrc: string;
  stampIndex?: number;
  audio?: string;
  style?: Object;
}

export default class StampItem extends React.PureComponent<Props> {
  click: (e: SyntheticEvent<HTMLDivElement | HTMLImageElement>) => void;
  audioClip: HTMLAudioElement;

  componentDidMount = () => {
    if (this.props.audio) {
      this.audioClip = document.createElement('audio');
      this.audioClip.src = this.props.audio || '';
    }
  }

  playAudio = () => {
    if (!this.audioClip) return;
    this.audioClip.play();
  }

  render(): React$Element<any> {
    return (
      <div
        className="flex justify-center portrait:my-2 landscape:mx-2 h-12 sm:h-16 md:h-20 lg:h-28 w-12 sm:w-16 md:w-20 lg:w-28"
        onMouseOver={this.playAudio}
        onClick={this.props.click}
        stampid={this.props.stampIndex}
      >
        <img alt="" src={this.props.img} className="h-full" />
      </div>
    );
  }
}
